import { Component, inject } from '@angular/core'
import { ION_COMPONENTS } from '@shared/ionic-components'
import { AppFlowService } from '@shared/services/app-flow.service'
import { AnalitycsService } from '@shared/services/analitycs.service'
@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.css'],
  imports: [ION_COMPONENTS],
})
export class NotFoundComponent {
  private readonly appFlowService = inject(AppFlowService)
  private readonly analitycsService = inject(AnalitycsService)
  redirect() {
    this.appFlowService.getStateApp().subscribe()
  }

  ionViewDidEnter() {
    this.analitycsService.setCurrentScreen('NOT FOUND - NOT FOUND')
  }
}
